
import Isotope from 'isotope-layout';

document.addEventListener('DOMContentLoaded', function() {
    const grid = document.querySelector('.blog-items');

    if (grid) {
        const filterButtons = document.querySelectorAll('.filter-button');

        // Initialize Isotope
        const iso = new Isotope(grid, {
            itemSelector: '.col',
            percentPosition: true,
            masonry: {
                columnWidth: '.col'
            }
        });

        // Function to check window width and reinitialize Isotope
        function checkWidth() {
            if (window.innerWidth < 768) {
                iso.options.layoutMode = 'vertical';
            } else {
                iso.options.layoutMode = 'fitRows';
                iso.options.fitRows = {
                    gutter: 24
                }
            }
            iso.layout();
        }

        // Run on load
        checkWidth();

        // Bind to window resize
        window.addEventListener('resize', checkWidth);

        filterButtons.forEach(button => {
            button.addEventListener('click', function() {
                const term = this.getAttribute('data-term');
                filterButtons.forEach(btn => btn.classList.remove('active'));
                this.classList.add('active');
                if (term === 'all') {
                    iso.arrange({filter: '*'});
                } else {
                    iso.arrange({filter: `[data-terms*="${term}"]`});
                }
            });
        });
    }
});